$(document).ready(function() {
    jQuery('.cart__items-wrapper,.cart__footer-wrapper').wrapAll('<section class="cart-page-section padding-bottom"><div class="container"><div class="row"></div></div></section>');
  jQuery('.cart-page-section .section-title.main').prependTo('.cart-page-section > .container');
    /********* On scroll heder Sticky *********/
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        if (scroll >= 50) {
            $("header").addClass("head-sticky");
            $('.announce-bar').slideUp('500');
        } else {
            $("header").removeClass("head-sticky");
            $('.announce-bar').slideDown('500');
        }
    });   
  
    /********* Mobile Menu ********/  
    $('.mobile-menu-button').on('click',function(e){
        e.preventDefault();
        setTimeout(function(){
            $('body').addClass('no-scroll active-menu');
            $(".mobile-menu-wrapper").toggleClass("active-menu");
            $('.overlay').addClass('menu-overlay');
        }, 50);
    }); 
    $('body').on('click','.overlay.menu-overlay, .menu-close-icon svg', function(e){
        e.preventDefault(); 
        $('body').removeClass('no-scroll active-menu');
        $(".mobile-menu-wrapper").removeClass("active-menu");
        $('.overlay').removeClass('menu-overlay');
    });
      /********* Mobile Filter Popup ********/
    $('.mobile-facets__open').on('click', function (e) {
      $('body').addClass('mobile-open no-scroll');
      $('.overlay').addClass('active');
    });
    $('.overlay,.close-filter,.apply-btn').on('click', function (e) {
      $('body').removeClass('mobile-open no-scroll');
      $('.overlay').removeClass('active');
    }); 
      /******* Subscribe popup Js *******/
    $('.close-sub-btn').click(function () {
        $('.subscribe-popup').slideUp(); 
        $(".subscribe-overlay").removeClass("open");
    }); 
    /********* Cart Popup ********/
    $('.main-cart').on('click', function (e) {
      $('body').addClass('no-scroll cartOpen');
    });
    $('body').on('click', '.overlay.cart-overlay, .closecart', function (e) {
        $('body').removeClass('no-scroll cartOpen');
    });
    /********* Mobile Filter Popup ********/
    $('.filter-title').on('click',function(e){
        e.preventDefault();
        setTimeout(function(){
            $('body').addClass('no-scroll filter-open');
            $('.overlay').addClass('active');
        }, 50);
    }); 
    $('body').on('click','.overlay.active, .close-filter', function(e){
        e.preventDefault(); 
        $('.overlay').removeClass('active');
        $('body').removeClass('no-scroll filter-open');
    });      
    /*********  Multi-level accordion nav  ********/ 
    $('.acnav-label').click(function () {
        var label = $(this);
        var parent = label.parent('.has-children');
        var list = label.siblings('.acnav-list');
        if (parent.hasClass('is-open')) {
            list.slideUp('fast');
            parent.removeClass('is-open');
        }
        else {
            list.slideDown('fast');
            parent.addClass('is-open');
        }
    });  
    /****  TAB Js ****/
    $('ul.tabs li').click(function(){
        var $this = $(this);
        var $theTab = $(this).attr('data-tab');
        console.log($theTab);
        if($this.hasClass('active')){
          // do nothing
        } else{
          $this.closest('.tabs-wrapper').find('ul.tabs li, .tabs-container .tab-content').removeClass('active');
          $('.tabs-container .tab-content[id="'+$theTab+'"], ul.tabs li[data-tab="'+$theTab+'"]').addClass('active');
        }
        $('.dietetist-slider').slick('refresh'); 
    });    
    /*****SCROLL TO BOTTOM *****/
    $('.click-btn').click(function(e){
        e.preventDefault();
        var target = $($(this).attr('href'));
        if(target.length){
            var scrollTo = target.offset().top - 80;
            $('body, html').animate({scrollTop: scrollTo+'px'}, 800);
        }
    });

    // currency
  function currencyFormSubmit(event) {
    event.target.form.submit();
  }

  document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
    element.addEventListener('change', currencyFormSubmit);
  });

    // coupan code
  $('body').on('keyup','.discount_coupan', function() {
   var apply_href = $('.apply').attr("href").split('discount=')[0];
   var val = $(this).val();
    $('.apply').attr("href",apply_href+'discount='+val);
  });

  // notify me
  $('body').on('click','.notify-btn', function(e) {
      e.preventDefault();
      $('body').addClass('no-scroll notify-active');
      $('.out-of-stock-form,.overlay').addClass('active');
    });
   $('body').on('click','.overlay,.notify-popup-close', function(e) {
      e.preventDefault();
     $('body').removeClass('no-scroll notify-active');
      $('.out-of-stock-form,.overlay').removeClass('active');
    });
  
// quickview
  $('body').on('click', '.quickview-close', function(e) {
    e.preventDefault();
    $('.quickview-popup').hide();
    $('body').removeClass('no-scroll quick-active');
  });
  
  $('body').on('click', '.quickview-btn, .show-qv', function(e) {
    e.preventDefault();
    $('body').addClass('no-scroll quick-active');
    var href= '/products/'+$(this).find('a').data('handle')+'?view=qv';
    $.get(href, function(product) {
      $('.quickview_popup_data').html(product);
      $('.qv_slider').slick({
          autoplay: false,
          slidesToShow: 1,
          speed: 1000,
          slidesToScroll: 1,
          arrows: true,
           prevArrow: '<button class="slide-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="9" viewBox="0 0 50 9" fill="none"> <path d="M49.3572 4.84961C49.5504 4.65232 49.5471 4.33576 49.3499 4.14254L46.1349 0.993875C45.9376 0.800657 45.621 0.803955 45.4278 1.00124C45.2346 1.19853 45.2379 1.51509 45.4352 1.70831L48.2929 4.50712L45.4941 7.36486C45.3009 7.56214 45.3042 7.87871 45.5015 8.07192C45.6988 8.26514 46.0153 8.26184 46.2086 8.06456L49.3572 4.84961ZM48.9948 3.99978L0.994793 4.49978L1.00521 5.49973L49.0052 4.99973L48.9948 3.99978Z" fill="white"/></svg></button>',
            nextArrow: '<button class="slide-arrow slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="9" viewBox="0 0 50 9" fill="none"> <path d="M49.3572 4.84961C49.5504 4.65232 49.5471 4.33576 49.3499 4.14254L46.1349 0.993875C45.9376 0.800657 45.621 0.803955 45.4278 1.00124C45.2346 1.19853 45.2379 1.51509 45.4352 1.70831L48.2929 4.50712L45.4941 7.36486C45.3009 7.56214 45.3042 7.87871 45.5015 8.07192C45.6988 8.26514 46.0153 8.26184 46.2086 8.06456L49.3572 4.84961ZM48.9948 3.99978L0.994793 4.49978L1.00521 5.49973L49.0052 4.99973L48.9948 3.99978Z" fill="white"/></svg></button>',
          dots: false,
          buttons: false,
          infinite: false,
          loop: false
      });

    });
    $('.quickview-popup').show();
  });

 $('body').on('change', '.nice-select.qv_select__select', function() {
    var selectedValues = [];

    // Collect selected option values
    $('.nice-select.qv_select__select').each(function() {
      var selectedValue = $(this).val();
      if (selectedValue) {
        selectedValues.push(selectedValue);
      }
    });
    var joinedValues = selectedValues.join(' / ');


    $('.variant-qv').each(function() {
     var variant_title = $(this).data('title'); 
     var variant_img = $('.variant-qv[data-title="'+variant_title+'"]').data('img');
     var variant_price = $('.variant-qv[data-title="'+variant_title+'"]').data('price');
     var qv_btn =  $('.variant-qv[data-title="'+variant_title+'"]').data('avail');
     var variant_id = $('.variant-qv[data-title="'+variant_title+'"]').data('id');
      variant_title = String(variant_title);
      joinedValues = String(joinedValues);
      
      if(variant_title === joinedValues){
      var slideIndex = $('.qv_slider .qv-pro-slider-img img[data-img="'+variant_img+'"]').parent().index();
      $('.qv_slider').slick('slickGoTo', slideIndex)
        
        $('.qv-price').find('.price-item--regular').text(variant_price);

        if(qv_btn === true ){
          $('#quick-view-temp .product-form__submit').find('span').text('Add to Cart');
          $('#quick-view-temp .product-form__submit').removeAttr('disabled');
          $('#quick-view-temp .quantity-select').show();
        }else{
          $('#quick-view-temp .product-form__submit').find('span').text('Sold out');
          $('#quick-view-temp .product-form__submit').attr('disabled', 'disabled');
          $('#quick-view-temp .quantity-select').hide();
        }

        $('input[name="id"]').val(variant_id);
        
      }
  });
  
  });
// end quickview

  if($('.featured-cat-slider').length > 0 ){
        $('.featured-cat-slider').slick({
            autoplay: false, 
            slidesToShow: 4,
            speed: 1000,
            slidesToScroll: 1,  
            buttons: false,
           prevArrow: '<button class="slide-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="9" viewBox="0 0 50 9" fill="none"> <path d="M49.3572 4.84961C49.5504 4.65232 49.5471 4.33576 49.3499 4.14254L46.1349 0.993875C45.9376 0.800657 45.621 0.803955 45.4278 1.00124C45.2346 1.19853 45.2379 1.51509 45.4352 1.70831L48.2929 4.50712L45.4941 7.36486C45.3009 7.56214 45.3042 7.87871 45.5015 8.07192C45.6988 8.26514 46.0153 8.26184 46.2086 8.06456L49.3572 4.84961ZM48.9948 3.99978L0.994793 4.49978L1.00521 5.49973L49.0052 4.99973L48.9948 3.99978Z" fill="white"/></svg></button>',
            nextArrow: '<button class="slide-arrow slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="9" viewBox="0 0 50 9" fill="none"> <path d="M49.3572 4.84961C49.5504 4.65232 49.5471 4.33576 49.3499 4.14254L46.1349 0.993875C45.9376 0.800657 45.621 0.803955 45.4278 1.00124C45.2346 1.19853 45.2379 1.51509 45.4352 1.70831L48.2929 4.50712L45.4941 7.36486C45.3009 7.56214 45.3042 7.87871 45.5015 8.07192C45.6988 8.26514 46.0153 8.26184 46.2086 8.06456L49.3572 4.84961ZM48.9948 3.99978L0.994793 4.49978L1.00521 5.49973L49.0052 4.99973L48.9948 3.99978Z" fill="white"/></svg></button>',
            responsive: [ 
                {
                    breakpoint: 1400,
                    settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1   
                    }
                },  
                {
                breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1 
                    }
                },
                {
                breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2 
                    }
                },
                {
                  breakpoint: 450,
                      settings: {
                          slidesToShow: 1,
                          slidesToScroll: 1 
                      }
                  }
            ]
        });
    }

  /** PDP slider **/
    $('.pdp-main-slider').slick({
        dots: false,
        infinite: true,
        speed: 1000,
        loop: true,
        slidesToShow: 1,
        arrows: false,
        asNavFor: '.pdp-thumb-slider',
    });
    $('.pdp-thumb-slider').slick({
           prevArrow: '<button class="slide-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="9" viewBox="0 0 50 9" fill="none"> <path d="M49.3572 4.84961C49.5504 4.65232 49.5471 4.33576 49.3499 4.14254L46.1349 0.993875C45.9376 0.800657 45.621 0.803955 45.4278 1.00124C45.2346 1.19853 45.2379 1.51509 45.4352 1.70831L48.2929 4.50712L45.4941 7.36486C45.3009 7.56214 45.3042 7.87871 45.5015 8.07192C45.6988 8.26514 46.0153 8.26184 46.2086 8.06456L49.3572 4.84961ZM48.9948 3.99978L0.994793 4.49978L1.00521 5.49973L49.0052 4.99973L48.9948 3.99978Z" fill="white"/></svg></button>',
            nextArrow: '<button class="slide-arrow slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="9" viewBox="0 0 50 9" fill="none"> <path d="M49.3572 4.84961C49.5504 4.65232 49.5471 4.33576 49.3499 4.14254L46.1349 0.993875C45.9376 0.800657 45.621 0.803955 45.4278 1.00124C45.2346 1.19853 45.2379 1.51509 45.4352 1.70831L48.2929 4.50712L45.4941 7.36486C45.3009 7.56214 45.3042 7.87871 45.5015 8.07192C45.6988 8.26514 46.0153 8.26184 46.2086 8.06456L49.3572 4.84961ZM48.9948 3.99978L0.994793 4.49978L1.00521 5.49973L49.0052 4.99973L48.9948 3.99978Z" fill="white"/></svg></button>',
        dots: false,
        asNavFor: '.pdp-main-slider', 
        speed: 1000, 
        slidesToScroll: 1,
        touchMove: true,
        focusOnSelect: true,
        loop: true,
        infinite: true,
        focusOnSelect: true,
        slidesToShow: 4,
        responsive: [{
                breakpoint: 1261,
                settings: {
                    slidesToShow: 3 
                }
            } 
        ]   
    });
    /***** HOME BANNER SLIDER *****/ 
    if ($('.banner-slider').length > 0) {
        $('.banner-slider').slick({
            arrows:true,
            rows:1,
            dots: false,
            loop:true,
            infinite: true,
            prevArrow: '<button class="slide-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="9" viewBox="0 0 50 9" fill="none"> <path d="M49.3572 4.84961C49.5504 4.65232 49.5471 4.33576 49.3499 4.14254L46.1349 0.993875C45.9376 0.800657 45.621 0.803955 45.4278 1.00124C45.2346 1.19853 45.2379 1.51509 45.4352 1.70831L48.2929 4.50712L45.4941 7.36486C45.3009 7.56214 45.3042 7.87871 45.5015 8.07192C45.6988 8.26514 46.0153 8.26184 46.2086 8.06456L49.3572 4.84961ZM48.9948 3.99978L0.994793 4.49978L1.00521 5.49973L49.0052 4.99973L48.9948 3.99978Z" fill="white"/></svg></button>',
            nextArrow: '<button class="slide-arrow slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="9" viewBox="0 0 50 9" fill="none"> <path d="M49.3572 4.84961C49.5504 4.65232 49.5471 4.33576 49.3499 4.14254L46.1349 0.993875C45.9376 0.800657 45.621 0.803955 45.4278 1.00124C45.2346 1.19853 45.2379 1.51509 45.4352 1.70831L48.2929 4.50712L45.4941 7.36486C45.3009 7.56214 45.3042 7.87871 45.5015 8.07192C45.6988 8.26514 46.0153 8.26184 46.2086 8.06456L49.3572 4.84961ZM48.9948 3.99978L0.994793 4.49978L1.00521 5.49973L49.0052 4.99973L48.9948 3.99978Z" fill="white"/></svg></button>',
            speed: 1000, 
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [{
                    breakpoint: 1202,
                    settings: {
                        prevArrow: '<button class="slide-arrow slick-prev"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
                        nextArrow: '<button class="slide-arrow slick-next"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });  
    } 
    /***** RATING SLIDER *****/ 
    if ($('.rating-slider').length > 0) {
        $('.rating-slider').slick({
            arrows:true,
            rows:1,
            dots: false,
            loop:true,
            prevArrow: '<button class="slide-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="9" viewBox="0 0 50 9" fill="none"> <path d="M49.3572 4.84961C49.5504 4.65232 49.5471 4.33576 49.3499 4.14254L46.1349 0.993875C45.9376 0.800657 45.621 0.803955 45.4278 1.00124C45.2346 1.19853 45.2379 1.51509 45.4352 1.70831L48.2929 4.50712L45.4941 7.36486C45.3009 7.56214 45.3042 7.87871 45.5015 8.07192C45.6988 8.26514 46.0153 8.26184 46.2086 8.06456L49.3572 4.84961ZM48.9948 3.99978L0.994793 4.49978L1.00521 5.49973L49.0052 4.99973L48.9948 3.99978Z" fill="white"/></svg></button>',
            nextArrow: '<button class="slide-arrow slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="9" viewBox="0 0 50 9" fill="none"> <path d="M49.3572 4.84961C49.5504 4.65232 49.5471 4.33576 49.3499 4.14254L46.1349 0.993875C45.9376 0.800657 45.621 0.803955 45.4278 1.00124C45.2346 1.19853 45.2379 1.51509 45.4352 1.70831L48.2929 4.50712L45.4941 7.36486C45.3009 7.56214 45.3042 7.87871 45.5015 8.07192C45.6988 8.26514 46.0153 8.26184 46.2086 8.06456L49.3572 4.84961ZM48.9948 3.99978L0.994793 4.49978L1.00521 5.49973L49.0052 4.99973L48.9948 3.99978Z" fill="white"/></svg></button>',
            speed: 1000, 
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [{
                    breakpoint:1202,
                    settings: {
                        arrows:false,
                        slidesToShow: 1,
                        dots:true,
                        slidesToScroll: 1
                    }
                },
            ]
        }); 
    }    
    /***** CLIENT SLIDER *****/ 
    if ($('.client-slider').length > 0) {
        $('.client-slider').slick({
            arrows:true,
            rows:1,
            dots: false,
            loop:true,
            prevArrow: '<button class="slide-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="9" viewBox="0 0 50 9" fill="none"> <path d="M49.3572 4.84961C49.5504 4.65232 49.5471 4.33576 49.3499 4.14254L46.1349 0.993875C45.9376 0.800657 45.621 0.803955 45.4278 1.00124C45.2346 1.19853 45.2379 1.51509 45.4352 1.70831L48.2929 4.50712L45.4941 7.36486C45.3009 7.56214 45.3042 7.87871 45.5015 8.07192C45.6988 8.26514 46.0153 8.26184 46.2086 8.06456L49.3572 4.84961ZM48.9948 3.99978L0.994793 4.49978L1.00521 5.49973L49.0052 4.99973L48.9948 3.99978Z" fill="white"/></svg></button>',
            nextArrow: '<button class="slide-arrow slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="9" viewBox="0 0 50 9" fill="none"> <path d="M49.3572 4.84961C49.5504 4.65232 49.5471 4.33576 49.3499 4.14254L46.1349 0.993875C45.9376 0.800657 45.621 0.803955 45.4278 1.00124C45.2346 1.19853 45.2379 1.51509 45.4352 1.70831L48.2929 4.50712L45.4941 7.36486C45.3009 7.56214 45.3042 7.87871 45.5015 8.07192C45.6988 8.26514 46.0153 8.26184 46.2086 8.06456L49.3572 4.84961ZM48.9948 3.99978L0.994793 4.49978L1.00521 5.49973L49.0052 4.99973L48.9948 3.99978Z" fill="white"/></svg></button>',
            speed: 1000, 
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [{
                    breakpoint:1202,
                    settings: {
                        prevArrow: '<button class="slide-arrow slick-prev"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
                        nextArrow: '<button class="slide-arrow slick-next"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
            ]
        }); 
    } 
    /***** ARTICLE SLIDER *****/ 
    if ($('.article-slide').length > 0) {
        $('.article-slide').slick({
            slidesToShow: 4,
            speed: 1000,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            infinite: true,
            prevArrow: '<button class="slide-arrow slick-prev"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
            nextArrow: '<button class="slide-arrow slick-next"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 3,
                  },
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 2,
                  },
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 1,
                  },
                },
              ],
        });
    }   
    /***** TESTIMONIALS SLIDER *****/
    if ($('.testimonials-slide').length > 0) {
        $('.testimonials-slide').slick({
            rows:1,
            dots: false,
            loop:true,
            prevArrow: '<button class="slide-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="9" viewBox="0 0 50 9" fill="none"> <path d="M49.3572 4.84961C49.5504 4.65232 49.5471 4.33576 49.3499 4.14254L46.1349 0.993875C45.9376 0.800657 45.621 0.803955 45.4278 1.00124C45.2346 1.19853 45.2379 1.51509 45.4352 1.70831L48.2929 4.50712L45.4941 7.36486C45.3009 7.56214 45.3042 7.87871 45.5015 8.07192C45.6988 8.26514 46.0153 8.26184 46.2086 8.06456L49.3572 4.84961ZM48.9948 3.99978L0.994793 4.49978L1.00521 5.49973L49.0052 4.99973L48.9948 3.99978Z" fill="white"/></svg></button>',
            nextArrow: '<button class="slide-arrow slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="9" viewBox="0 0 50 9" fill="none"> <path d="M49.3572 4.84961C49.5504 4.65232 49.5471 4.33576 49.3499 4.14254L46.1349 0.993875C45.9376 0.800657 45.621 0.803955 45.4278 1.00124C45.2346 1.19853 45.2379 1.51509 45.4352 1.70831L48.2929 4.50712L45.4941 7.36486C45.3009 7.56214 45.3042 7.87871 45.5015 8.07192C45.6988 8.26514 46.0153 8.26184 46.2086 8.06456L49.3572 4.84961ZM48.9948 3.99978L0.994793 4.49978L1.00521 5.49973L49.0052 4.99973L48.9948 3.99978Z" fill="white"/></svg></button>',
            speed: 1000, 
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1202,
                    settings: {
                        prevArrow: '<button class="slide-arrow slick-prev"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
                        nextArrow: '<button class="slide-arrow slick-next"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
                    },
                  },
                {
                  breakpoint: 992,
                  settings: {
                    slidesToShow: 2,
                         prevArrow: '<button class="slide-arrow slick-prev"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
                         nextArrow: '<button class="slide-arrow slick-next"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
                  },
                },
                {
                  breakpoint: 630,
                  settings: {
                    slidesToShow: 1,
                    prevArrow: '<button class="slide-arrow slick-prev"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
                    nextArrow: '<button class="slide-arrow slick-next"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
                  },
                },
              ],
        }); 
    }    

});  
/********* Wrapper top space ********/
$(window).on('load resize orientationchange', function() { 
    var header_hright = $('header').outerHeight();
    $('header').next('.wrapper').css('margin-top', header_hright + 'px');  
}); 
/********* Wrapper top space End********/
/******  STEPPY FORM  CSS  ******/
$('.date-labls li').on('click',  function(){
    $('.date-labls li').removeClass('active')
    $(this).addClass('active')
  })
  $('.time-labls li').on('click',  function(){
    $('.time-labls li').removeClass('active')
    $(this).addClass('active')
  })

var totalSteps = $(".steps li").length;
$(".submit").on("click", function(){
  return false; 
});

$(".steps li:nth-of-type(1)").addClass("active");
$(".myContainer .step-container:nth-of-type(1)").addClass("active");

$(".step-container").on("click", ".next", function() { 
  $(".steps li").eq($(this).parents(".step-container").index() + 1).addClass("active"); 
  $(this).parents(".step-container").removeClass("active").next().addClass("active"); 
  $('.right-slider').slick('refresh');  
});

$(".step-container").on("click", ".back", function() {  
  $(".steps li").eq($(this).parents(".step-container").index() - totalSteps).removeClass("active"); 
  $(this).parents(".step-container").removeClass("active").prev().addClass("active"); 
  $('.right-slider').slick('refresh');
}); 
/******  STEPPY FORM  CSS  End******/
function responsiveMenu(){
  if(jQuery(window).width() < 768) {
    $('.product-filter-column').prependTo('.product-heading-row .container .row');
  }
  else { 
    $('.product-filter-column').prependTo('.product-list-row');
  }
}
jQuery(document).ready(function() {
  responsiveMenu();
});
jQuery(window).resize(function() {
  responsiveMenu();
});